import { useCallback } from 'react';
import { erc20Abi } from 'viem';
import { useWriteContractWithReceipt } from '@/onchain/hooks/useWriteContractWithReceipt';
import { Erc20ApproveParams } from '@/types';

export const useERC20Approve = (erc2oApproveParams: Erc20ApproveParams) => {
  const { spender, amount, tokenAddress } = erc2oApproveParams;

  const {
    hash,
    // write state
    writeError,
    isWriteError,
    isWritePending,
    // confirm state
    confirmError,
    isConfirmLoading,
    isConfirmSuccess,
    isConfirmError,
    // tx receipt
    receipt,
    // write function
    writeContract,
    writeContractAsync,
    reset,
  } = useWriteContractWithReceipt();

  const write = useCallback(() => {
    writeContract({
      address: tokenAddress,
      abi: erc20Abi,
      functionName: 'approve',
      args: [spender, amount],
    });
  }, [spender, amount, tokenAddress, writeContract]);

  const writeAsync = useCallback(async () => {
    await writeContractAsync({
      address: tokenAddress,
      abi: erc20Abi,
      functionName: 'approve',
      args: [spender, amount],
    });
  }, [spender, amount, tokenAddress, writeContractAsync]);

  return {
    hash,
    writeError,
    isWriteError,
    isWritePending,
    confirmError,
    isConfirmLoading,
    isConfirmSuccess,
    isConfirmError,
    receipt,
    write,
    writeAsync,

    reset,
  };
};
